import type { Seq } from 'immutable';
import { createAction } from '@reduxjs/toolkit';

import type { FontAsset } from 'js/src/client';
import { FONTS_ACTIONS } from 'js/src/data/fonts/fonts-types';
import type { ImmutableMap } from 'js/src/libs/consts';

export const beginLoadingFonts = createAction<undefined>(FONTS_ACTIONS.BEGIN_LOADING_FONTS);

export const storeFonts = createAction<{
    fontList: Seq.Indexed<ImmutableMap<FontAsset>> | Immutable.List<ImmutableMap<FontAsset>>;
}>(FONTS_ACTIONS.STORE_FONTS);

export const archiveFontWithId = createAction<{
    fontId: number;
}>(FONTS_ACTIONS.ARCHIVE_FONT_WITH_ID);
